import { type ImgHTMLAttributes } from "react";
import { generateCMSImageUrl } from "@utils/cms";
import type { ICMSMedia } from "@/types";

interface ICMSImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  image?: ICMSMedia;
}

export const CMSImage: React.FC<ICMSImageProps> = ({ image, ...rest }) => {
  return (
    <img
      {...rest}
      src={image?.url ? generateCMSImageUrl(image.url) : ""}
      alt={image?.alternativeText ?? rest.alt ?? ""}
    />
  );
};
